import { render, staticRenderFns } from "./SenderTemplate.vue?vue&type=template&id=4966dc3c&scoped=true&"
import script from "./SenderTemplate.vue?vue&type=script&lang=js&"
export * from "./SenderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966dc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4966dc3c')) {
      api.createRecord('4966dc3c', component.options)
    } else {
      api.reload('4966dc3c', component.options)
    }
    module.hot.accept("./SenderTemplate.vue?vue&type=template&id=4966dc3c&scoped=true&", function () {
      api.rerender('4966dc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/SenderTemplate.vue"
export default component.exports